import { z } from 'zod';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { FilterDefinitionForExtras } from 'libs/end-to-end/src/types/databases/filters/filter-definition';

export const ProgressExtras = z
  .object({
    dimension: z.string(),
    focusArea: FocusArea,
    metric: z.string(),
    filters: z.array(FilterDefinitionForExtras),
  })
  .describe('ProgressExtras');

export type ProgressExtras = z.infer<typeof ProgressExtras>;

export const ProgressInputs = z.object({
  dropdowns: EmptyObject,
  extras: ProgressExtras,
});

export const ProgressRequest = createCustomVizRequestSchema(
  'progress',
  ProgressInputs,
);

export type ProgressRequest = z.infer<typeof ProgressRequest>;
